import { ShieldAlert } from 'lucide-react'

import { t } from '@/i18n'
import { useAuth } from '@/hooks/useAuth'

interface RoleGateProps {
  /** Solo el administrador entra. */
  adminOnly?: boolean
  /** El contador no entra (pantallas que escriben). */
  noAccountant?: boolean
  /** El vendedor no entra (historiales: los ven el admin y el contador). */
  noSeller?: boolean
  children: React.ReactNode
}

/** Corta en la pantalla lo que el backend igual rechazaría con 403. */
export function RoleGate({ adminOnly = false, noAccountant = false, noSeller = false, children }: RoleGateProps) {
  const { isAdmin, isAccountant, isSeller } = useAuth()
  const blocked = (adminOnly && !isAdmin) || (noAccountant && isAccountant) || (noSeller && isSeller)
  if (!blocked) return <>{children}</>
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3 text-center">
      <ShieldAlert className="h-10 w-10 text-muted-foreground" aria-hidden="true" />
      <p className="text-muted-foreground">
        {isAccountant ? t('approvals.readOnly') : t('approvals.adminOnlyAction')}
      </p>
    </div>
  )
}
